import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appAllGetHubs } from '../../store/hubs'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetFundrasing } from '../../store/fundrasing'
import ReceiptPDF from '../../components/filegenerate/filegenerate'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter() {
	const dispatch = useDispatch()
	const params = useParams()

	const [page, setPage] = useState(params.page || 1)
	const paginate = useSelector(state => state.fundrasingReducer.paginate)
	const isloder = useSelector(state => state?.facilitybookingReducer.isloder)
	const hub = useSelector(state => state?.hubReducer.hub)
	const sanstha = useSelector(state => state?.sansthaReducer.sanstha)
	const fundrasing = useSelector(state => state?.fundrasingReducer.fundrasing)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({
		sanstha: null,
		hub: null,
		contributionType: null,
		startDate: null,
		endDate: null,
		paymentRef: '',
	})
	const [error, setError] = useState('')

	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, loading: false }))
		dispatch(appAllGetHubs({ page: 1, limit: 1000, loading: false }))
	}, [])

	useEffect(() => {
		const searchParams = {
			...activeFilters,
			page,
			limit: 10,
		}
		//   console.log(searchParams);
		dispatch(appAllGetFundrasing(searchParams))
	}, [page, activeFilters])

	const handleSearch = useCallback(() => {
		if (selectedFilters.startDate && !selectedFilters.endDate) {
			setError('Please select an end date.')
			return
		}

		setError('')
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.contributionType) {
			filters.contributionType = selectedFilters.contributionType
		}
		if (selectedFilters.startDate) {
			filters.startDate = selectedFilters.startDate
		}
		if (selectedFilters.endDate) {
			filters.endDate = selectedFilters.endDate
		}

		if (selectedFilters.paymentRef) {
			filters.paymentRef = selectedFilters.paymentRef
		}
		setActiveFilters(filters)
		setPage(1)
	}, [selectedFilters])

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Community</label>
								<Select
									options={
										Array.isArray(hub.data)
											? hub.data.map(hub => ({
													value: hub?._id,
													label: toCamelCase(hub?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											hub: option,
										}))
									}}
									value={selectedFilters.hub}
									placeholder="Select Community.."
									getOptionLabel={option => option.label}
									getOptionValue={option => option.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Sanstha</label>
								<Select
									options={
										Array.isArray(sanstha)
											? sanstha.map(sanstha => ({
													value: sanstha?._id,
													label: toCamelCase(sanstha?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											sanstha: option,
										}))
									}}
									value={selectedFilters.sanstha}
									placeholder="Select Sanstha.."
									getOptionLabel={option => option?.name || option?.label}
									getOptionValue={option => option?._id || option?.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Contribution Type</label>
								<select
									className="form-control"
									name="contributionType"
									value={selectedFilters.contributionType || ''}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											contributionType: e.target.value || null,
										}))
									}}
								>
									<option value="">Select Contribution Type</option>
									<option value="Membership Subscription">Membership Subscription</option>
									<option value="Boli Contributions">Boli Contributions</option>{' '}
									<option value="Social Project Donations">Social Project Donations</option>{' '}
									<option value="Voluntary Contribution">Voluntary Contribution</option>
									<option value="Sales/Service Collections">Sales/Service Collections</option>
									<option value="Facility Booking">Facility Booking</option>
								</select>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Start Date</label>
								<input
									type="date"
									className="form-control"
									max={new Date().toISOString().split('T')[0]}
									value={selectedFilters.startDate || ''}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											startDate: value,
											endDate: prev.endDate && prev.endDate < value ? '' : prev.endDate,
										}))
									}}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>End Date</label>
								<input
									type="date"
									className="form-control"
									min={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									value={selectedFilters.endDate || ''}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											endDate: value,
										}))
										if (value) {
											setError('')
										}
									}}
								/>
								{error && <span className="text-danger">{error}</span>}
							</div>
						</div>

						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										sanstha: null,
										hub: null,
										startDate: null,
										endDate: null,
										paymentRef: '',
									})
									setActiveFilters({})
									setPage(1)
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Search by Reference No</label>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Reference No"
									value={selectedFilters.paymentRef || ''}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											paymentRef: e.target.value,
										}))
									}}
								/>
							</div>
						</div>

						<div className="col text-right">
							<div style={{ fontSize: '18px' }}>
								Total Fundraising : ₹ {fundrasing?.totalAmount}
							</div>
						</div>
					</div>

					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Community</th>
									<th>Sanstha</th>
									<th>User</th>
									<th>Contribution Type</th>
									<th>Payment Screenshot</th>
									<th>Online/Offline</th>
									<th>Amount</th>
									<th>Payment Date</th>
									<th>payment Reference No</th>
									<th>Action</th>

									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{fundrasing?.data &&
								fundrasing?.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td>
													{value?.hub ? (
														<>
															{value.hub.image && <PostPreview value={value.hub.image} />}
															{value?.hub?.name || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													{value?.sansthaId ? (
														<>
															{value.sansthaId.image && (
																<PostPreview value={value.sansthaId.image} />
															)}
															{value.sansthaId.name || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />
													{value?.userId?.firstName} {value?.userId?.lastName}
													<br />
													<small>{value?.userId?.mobile}</small>
												</td>
												<td>
													<br />
													{value.fundraisingType}
												</td>
												<PostPreview value={value?.paymentScreenshot} />

												<td>
													{value.isOnline}
													{value?.isOnline === true ? (
														<span className="badge badge-primary">Online</span>
													) : (
														<span className="badge badge-primary">Offline</span>
													)}
												</td>
												<td>
													₹<span style={{ fontWeight: 'bold' }}>{value?.amount}</span> <br />
													{value?.offlinePaymentMode && (
														<small>Mode: {value?.offlinePaymentMode}</small>
													)}
												</td>
												<td>
													{new Date(value?.paymentDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>{value?.paymentRef}</td>
												<td>
													<ReceiptPDF data={value?._id} />
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
